<header class="header" [class]="eternalPage ? 'eternalPage' : ''">
  <div *ngIf="eternalPage" class="header__eternalPage">
    <div class="header__wrap">
      <div class="header__title-wrap">
        <h1 class="header__title">Kreditcenter</h1>
        <p class="header__text">
          Alle Kreditangebote & Abschlüsse auf einen Blick
        </p>
      </div>
      <app-header-trust-elements></app-header-trust-elements>
    </div>
    <div class="eternalPage__buttons">
      <div class="buttons__pages">
        <a
          href="/start/kreditcenter/"
          routerLink=""
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="pages__eternal"
        >
          Angebote
        </a>
        <a routerLink="/active" routerLinkActive="active" class="pages__active">
          Aktiv
        </a>
        <a
          routerLink="/archive"
          routerLinkActive="active"
          class="pages__archive"
        >
          Archiv
        </a>
        <a routerLink="/info" routerLinkActive="active" class="pages__info">
          Informationen
        </a>
      </div>
      <a href="/start/kredit-apptrack-v2" class="buttons__link">neu vergleichen</a>
    </div>
  </div>
  <div *ngIf="!eternalPage" class="header__resultPage">
    <div class="header__wrap">
      <div class="header__title-wrap">
        <h1 *ngIf="resultPage" class="offer__title">Ihre Kreditangebote</h1>
        <div class="amount">
          <p
            *ngIf="search"
            [class]="searchAnimation ? 'rollingTextTop' : 'rollingTextBottom'"
          >
            Wir suchen nach den besten Krediten für Sie...
          </p>
          <p
            *ngIf="loadedData"
            class="amount__ok rollingTextTop"
            [class]="finishedSearchAnimation ? '' : 'rollingTextBottom'"
          >
            <span class="amount__icon-ok"></span>Kredite sind fertig geladen
          </p>
          <p *ngIf="showAlternativesHeaderLine" class="rollingTextTop">
            <span class="amount__icon-exclamation">!</span> Keine Treffer zu
            Ihrer Suche über
            <span class="amount__loanAmount"
              >{{ loanFilterDataValue | currency: "EUR" : "" : "1.0-0" }} € für
              {{ loanFilterDataDuration }} Monate...</span
            ><span *ngIf="showAlternativeSuffix">
              Hier sind Ihre Alternativen.</span
            >
          </p>
          <p *ngIf="showInstallmentSummaryHeader" class="rollingTextTop">
            <ng-container *ngIf="showSingleOfferInstallmentCopy; else multiOfferCopy">
              Einen Kredit für
              <strong>
                <span class="amount__from">{{
                  minRate.toLocaleString("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}</span>
                €
              </strong>
              monatlich
            </ng-container>
            <ng-template #multiOfferCopy>
              <ng-container *ngIf="minEqualsMaxRate; else headerInstallmentRange">
                Kredite für
                <strong>
                  <span class="amount__from">{{
                    minRate.toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}</span>
                  €
                </strong>
                monatlich
              </ng-container>
              <ng-template #headerInstallmentRange>
                Kredite von
                <strong>
                  <span class="amount__from">
                    {{
                      minRate.toLocaleString("de-DE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }} </span
                  >€ -
                  <span class="amount__to">{{
                    maxRate.toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}</span>
                  €
                </strong>
                monatlich
              </ng-template>
            </ng-template>
          </p>
          <p
            *ngIf="anyOffers && !twoApplicants && offersData?.length > 0"
            class="rollingTextTop text"
          >
            Fügen Sie einen zweiten Kreditnehmer hinzu, um Ihre Bonität zu
            verbessern.
          </p>
        </div>
      </div>
      <app-header-trust-elements></app-header-trust-elements>
    </div>
  </div>
</header>
